import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as AppMapping from '@services/store/actions/app'

export const useAppLoader = () => {
    const store = useStore()
    const app = bindActionCreators(AppMapping, store.dispatch)
    const appStore = useSelector(state => state.app.loader)

    const show = (message = 'LOADING') => {
        app.showLoader(message)
    }

    const hide = () => {
        app.hideLoader()
    }

    return { show, hide, config: appStore }
}